import script from "./FatigueManageFormTextView.vue?vue&type=script&setup=true&lang=js"
export * from "./FatigueManageFormTextView.vue?vue&type=script&setup=true&lang=js"

import "./FatigueManageFormTextView.vue?vue&type=style&index=0&id=df708992&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df708992"]])

export default __exports__